// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Image_imageWrapper__m8qmz","image":"Image_image__tzQM0","cardSlot":"Image_cardSlot__NCRoM"};